import { Slider, Typography } from "@mui/material";

import { SliderWithCommit } from "@/baseComponents";

import { useFilterContext } from "../FilterContext";

const FilterItemPoints = () => {
  const { filterData, setFilterData, filterOptions } = useFilterContext();
  return (
    <div className="pt-[40px] pb-[12px] px-[40px] space-y-[20px]">
      <div>
        <Typography color="textPrimary">Economy:</Typography>
        <SliderWithCommit
          valueLabelDisplay="on"
          min={filterOptions.maxPointsRangeEconomy[0]}
          max={filterOptions.maxPointsRangeEconomy[1]}
          key={filterOptions.maxPointsRangeEconomy[1]}
          step={500}
          value={
            filterData.maxPoints[0] === -1
              ? filterOptions.maxPointsRangeEconomy[1]
              : filterData.maxPoints[0]
          }
          valueLabelFormat={(v: number) => `${Math.ceil(v / 1000)}K`}
          onChangeCommitted={(e, v) => {
            const val = [...filterData.maxPoints];
            val[0] = (v as number) === filterOptions.maxPointsRangeEconomy[1] ? -1 : (v as number);
            setFilterData({
              maxPoints: val,
            });
          }}
        />
      </div>

      <div>
        <Typography color="textPrimary">Premium Economy:</Typography>
        <SliderWithCommit
          valueLabelDisplay="on"
          min={filterOptions.maxPointsRangePremiumEconomy[0]}
          max={filterOptions.maxPointsRangePremiumEconomy[1]}
          key={filterOptions.maxPointsRangePremiumEconomy[1]}
          step={500}
          value={
            filterData.maxPoints[1] === -1
              ? filterOptions.maxPointsRangePremiumEconomy[1]
              : filterData.maxPoints[1]
          }
          valueLabelFormat={(v: number) => `${Math.ceil(v / 1000)}K`}
          onChangeCommitted={(e, v) => {
            const val = [...filterData.maxPoints];
            val[1] =
              (v as number) === filterOptions.maxPointsRangePremiumEconomy[1] ? -1 : (v as number);
            setFilterData({
              maxPoints: val,
            });
          }}
        />
      </div>

      <div>
        <Typography color="textPrimary">Business:</Typography>
        <SliderWithCommit
          valueLabelDisplay="on"
          min={filterOptions.maxPointsRangeBusiness[0]}
          max={filterOptions.maxPointsRangeBusiness[1]}
          key={filterOptions.maxPointsRangeBusiness[1]}
          step={500}
          value={
            filterData.maxPoints[3] === -1
              ? filterOptions.maxPointsRangeBusiness[1]
              : filterData.maxPoints[3]
          }
          valueLabelFormat={(v: number) => `${Math.ceil(v / 1000)}K`}
          onChangeCommitted={(e, v) => {
            const val = [...filterData.maxPoints];
            val[3] = (v as number) === filterOptions.maxPointsRangeBusiness[1] ? -1 : (v as number);
            setFilterData({
              maxPoints: val,
            });
          }}
        />
      </div>

      <div>
        <Typography color="textPrimary">First:</Typography>
        <SliderWithCommit
          valueLabelDisplay="on"
          min={filterOptions.maxPointsRangeFirst[0]}
          max={filterOptions.maxPointsRangeFirst[1]}
          key={filterOptions.maxPointsRangeFirst[1]}
          step={500}
          value={
            filterData.maxPoints[2] === -1
              ? filterOptions.maxPointsRangeFirst[1]
              : filterData.maxPoints[2]
          }
          valueLabelFormat={(v: number) => `${Math.ceil(v / 1000)}K`}
          onChangeCommitted={(e, v) => {
            const val = [...filterData.maxPoints];
            val[2] = (v as number) === filterOptions.maxPointsRangeFirst[1] ? -1 : (v as number);
            setFilterData({
              maxPoints: val,
            });
          }}
        />
      </div>
    </div>
  );
};

export default FilterItemPoints;
